import React, { useState } from 'react'
import {
  removeAccessToken,
  removeOrgFromStorage,
  removeUserInfoFromStorage,
} from 'utils/common'
import { useNavigate } from 'react-router-dom'
import { LOGIN_PATH } from 'constants/RoutePaths'
import PropTypes from 'prop-types'
import Sidebar from './sidebar/Sidebar'
import Header from './header/Header'

function Layout({ children }) {
  const navigate = useNavigate()
  const [collapsed, setCollapsed] = useState(false)
  const logoutHandler = () => {
    removeAccessToken()
    removeUserInfoFromStorage()
    removeOrgFromStorage()
    navigate(LOGIN_PATH)
  }

  return (
    <div className={collapsed ? 'app-shell is-collapsed' : 'app-shell'}>
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed((open) => !open)}
      />
      <main className='body-content has-sidebar'>
        <Header logoutHandler={logoutHandler} />
        {children}
      </main>
    </div>
  )
}
Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
